// parseLevelThreshold.js
'use strict';

/**
 * Parse level threshold

 * Parses USER_LEVEL_BENEFIT_THRESHOLD from remote config
 * into a structured, reusable level threshold definition.
 *
 * The remote config value should follow the format:
 *   "<level>:<min>~<max> <level>:<min>~<max> ..."
 *
 * Example:
 *   USER_LEVEL_BENEFIT_THRESHOLD = "1:1~10 2:11~20 3:21~30 ..."
 *
 * This parsed structure serves as the single source of truth
 * for both forward (value → level) and reverse (level → range) lookups.
 *
 * @param {string[]} thresholds *   Raw threshold string fetched from remote config.
 *
 * @returns {Array<{ level: number, min: number, max: number }>}
 *   Parsed level threshold definitions.
 */
const parseLevelThreshold = ({ threshold } = {}) => {
  return threshold.map(item => {
    const [level, range] = item.split(':');
    const [min, max] = range.split('~').map(Number);

    return {
      level: +level,
      min,
      max,
    };
  });
};

export default parseLevelThreshold;
